export default "__VITE_ASSET__CgajO6Dz__"